import { render, staticRenderFns } from "./TestResultsSwalComponent.vue?vue&type=template&id=600aff2c&scoped=true"
import script from "./TestResultsSwalComponent.vue?vue&type=script&lang=js"
export * from "./TestResultsSwalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600aff2c",
  null
  
)

export default component.exports